export default __webpack_public_path__ + "static/media/-1-1716808877047.19141805.png";